// Carry Roll navigation helper.
//
// calc-sidebar's SidebarNav owns top-level navigation via the URL hash
// (`#nav/<item-id>`). Other shell chrome (Header home button, QuickSettings
// "all settings" link) need to drive the same navigation, so they set the hash.
// Assigning `location.hash` fires `popstate`, which the sidebar listens for and
// reacts to — keeping a single source of truth (the hash) without React Router.

export const NAV_SECTION = 'nav';

/** Navigate to a top-level sidebar item by id. */
export function goNav(itemId: string): void {
  window.location.hash = `#${NAV_SECTION}/${itemId}`;
}

/** The active sidebar item id derived from the current URL hash. */
export function activeNavId(): string {
  const hash = window.location.hash.slice(1);
  const slash = hash.indexOf('/');
  if (slash === -1) return '';
  const section = hash.slice(0, slash);
  return section === NAV_SECTION ? hash.slice(slash + 1) : '';
}
